import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';
import { useFormikContext } from 'formik';
import { LotsManagementEditVM } from 'front-office/view-models/lots-management/edit';
import { ReactElement } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { noop } from 'shell/utils/noop';

interface FormEditProps {
  disabled?: boolean;
}

const FormEdit = ({ disabled }: FormEditProps): ReactElement => {
  const formContext = useFormikContext<LotsManagementEditVM>();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Servizio"
          label="Servizio"
          id="service"
          name="service"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values?.service || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Operatore"
          label="Operatore"
          id="operator"
          name="operator"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values?.operator || ''}
          onChange={noop}
          disabled
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Nascita"
            id="isRectificationCards"
            value={formContext.values?.isRectificationCards || 'false'}
            onChange={() =>
              formContext.setFieldValue(
                'isRectificationCards',
                !formContext.values?.isRectificationCards || false
              )
            }
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              disabled={disabled}
              label="Rettifica inizio/fine lotto"
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              disabled={disabled}
              label="Rettifica numero carte rilasciate"
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Inzio Lotto"
          label="Inzio Lotto"
          id="fromNumber"
          name="fromNumber"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values?.fromNumber || ''}
          onChange={(event) => formContext.setFieldValue('fromNumber', event.target.value || '')}
          error={formContext.touched.fromNumber && Boolean(formContext.errors.fromNumber)}
          helperText={formContext.errors.fromNumber}
          inputProps={{
            maxLength: '9',
          }}
          disabled={
            formContext.values?.isRectificationCards ||
            formContext.values?.released !== 0 ||
            disabled
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Fine lotto"
          label="Fine lotto"
          id="toNumber"
          name="toNumber"
          fullWidth
          type="text"
          variant="outlined"
          value={formContext.values?.toNumber || ''}
          onChange={(event) => formContext.setFieldValue('toNumber', event.target.value || '')}
          error={formContext.touched.toNumber && Boolean(formContext.errors.toNumber)}
          helperText={formContext.errors.toNumber}
          inputProps={{
            maxLength: '9',
          }}
          disabled={
            formContext.values?.isRectificationCards ||
            formContext.values?.released !== 0 ||
            disabled
          }
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <PmiTextField
          aria-label="Totale rilasciate"
          label="Totale rilasciate"
          id="released"
          name="released"
          fullWidth
          type="number"
          variant="outlined"
          value={formContext.values?.released || 0}
          onChange={(event) => {
            const formattedValue = Number.parseInt(event.target.value, 10) || 0;
            if (formattedValue >= 0) {
              formContext.setFieldValue('released', formattedValue);
            }
          }}
          error={formContext.touched.released && Boolean(formContext.errors.released)}
          helperText={formContext.errors.released}
          disabled={!formContext.values?.isRectificationCards || disabled}
        />
      </Grid>
    </Grid>
  );
};

FormEdit.displayName = 'Lots Management Edit - Form Page component';

export default FormEdit;
